import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AcctStateType } from 'stores/atoms/acctState';
import { derivePlanStatus } from '../utils/planStatus';

export interface UseWsIndexResult {
  modalCreateContentOpen: boolean;
  setModalCreateContentOpen: (open: boolean) => void;
  onModalCreateContentOpen: () => void;
  isTrial: boolean;
  isExpiredPlan: boolean;
}

export function useWsIndex(acctState: AcctStateType): UseWsIndexResult {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const navigate = useNavigate();
  const [modalCreateContentOpen, setModalCreateContentOpen] = useState(false);

  const { isTrial, isExpiredPlan } = derivePlanStatus(acctState.company.plan);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    if (acctState.proxyLogin && acctState.user?.companies.length === 0) {
      navigate('/404');
    }
  }, [acctState.proxyLogin, acctState.user?.companies, navigate]);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * コンテンツ作成モーダルを開く
   */
  const onModalCreateContentOpen = () => {
    setModalCreateContentOpen(true);
  };

  return {
    modalCreateContentOpen,
    setModalCreateContentOpen,
    onModalCreateContentOpen,
    isTrial,
    isExpiredPlan,
  };
}
